module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs-center my-5"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('pageNotFound.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pageNotFound.pageNotFound')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-103d2e4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound.vue
// module id = 1052
// module chunks = 1